import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import {Heart, Home, BadgeDollarSign, ChartCandlestick, UserRound,Wallet} from "lucide-react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";

function BottomNav({classes,global_menu}) {
    const location = useLocation();
    const [value, setValue] = React.useState(location.pathname);
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        navigate(newValue);
        setValue(newValue);
    };
    const { t } = useTranslation();

    return (
        <BottomNavigation className={classes.bottomNav} value={value} onChange={handleChange}>
            <BottomNavigationAction
                label={t('home')}
                value="/"
                icon={<Home className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('bsRequests')}
                value={"/bs-requests/view-all"}
                icon={<BadgeDollarSign className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('myStocks')}
                value={"/stocks/view-all"}
                icon={<ChartCandlestick className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('wallet')}
                value="/user/wallet"
                icon={<Wallet className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('account')}
                value="/user/account"
                icon={<UserRound className="lucide-large"/>}
            />
        </BottomNavigation>
    );
}
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    global_menu: state.global_menu,

});
export default withStyles(Styles)(connect(mstp)(BottomNav));
